/**
 * Native browser button enumeration
 */
export enum NativePointerButton {
  NoButton = -1,
  Left = 0,
  Middle = 1,
  Right = 2,
  Unknown = 3
}
